<div class="mb-10 mct-flex mct-row mct-justify-end mct-items-stretch">
  <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="navigateToNewQuery()">
    {{ 'reports.query-tool.create-query' | translate | uppercase }}
  </button>
</div>
<div class="atlas-table">
  <p-table [showGridlines]="true" [value]="searchResult?.Result" [paginator]="true" [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount" (onLazyLoad)="lazyLoad($event)" [lazy]="true"
    [rowsPerPageOptions]="[10, 20, { showAll: 'All' }]">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'reports.saved-queries.run' | translate | titlecase }}</th>
        <th pSortableColumn="Name">
          {{ 'common.name' | translate | titlecase }}
          <p-sortIcon field="Name"></p-sortIcon>
        </th>
        <th pSortableColumn="Descr">
          {{ 'common.description' | translate | titlecase }}
          <p-sortIcon field="Descr"></p-sortIcon>
        </th>
        <th pSortableColumn="DateCreated">
          {{ 'common.date-created' | translate | titlecase }}
          <p-sortIcon field="DateCreated"></p-sortIcon>
        </th>
        <th pSortableColumn="ChangedBy">
          {{ 'common.changed-by' | translate | titlecase }}
          <p-sortIcon field="ChangedBy"></p-sortIcon>
        </th>
        <th pSortableColumn="DateChanged">
          {{ 'common.date-changed' | translate | titlecase }}
          <p-sortIcon field="DateChanged"></p-sortIcon>
        </th>
        <th class="actions-column"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-savedQuery>
      <tr>
        <td style="width: 49px">
          <div class="flex row-collapse space-around">
            <a [routerLink]="['/reports', 'querytool', savedQuery.Id, 'run']">
              <img src="../../../assets/img/play-run-icon.svg" />
            </a>
          </div>
        </td>
        <td>
          {{ savedQuery.Name }}
        </td>
        <td class="t-ac">
          <div class="mr-12 mct-flex mct-row mct-justify-between mct-items-stretch">
            <span>
              {{ savedQuery.Descr }}
            </span>
            <div>
              <div *ngIf="savedQuery.IsRawSql" class="sql-tag">
                <strong>{{ 'reports.saved-queries.sql-code' | translate }}</strong>
              </div>
              <div *ngIf="savedQuery.UserNum > 0" class="pi pi-lock"
                title=" {{ 'reports.saved-queries.lock-icon' | translate }}"></div>
            </div>
          </div>
        </td>
        <td>
          {{ savedQuery.DateCreated | date: 'MM/dd/yyyy' }}
        </td>
        <td>
          {{ savedQuery.ChangedBy }}
        </td>
        <td>
          {{ savedQuery.DateChanged | date: 'MM/dd/yyyy' }}
        </td>
        <td style="width: 220px">
          <div class="flex row-collapse space-between ph-10">
            <button pButton type="button" class="atlas-btn atlas-btn-primary link-button"
              (click)="openEditDataQuery(savedQuery)">
              {{ 'common.edit' | translate | uppercase }}
            </button>
            <action-button styleClass="atlas-btn atlas-btn-primary link-button"
              [label]="'common.actions' | translate | uppercase" [items]="actionItemsForDataQuery(savedQuery)">
            </action-button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
</div>

<p-confirmDialog #cd key="deleteDataQueryCD" header="{{ 'reports.saved-queries.delete-header' | translate | ucfirst }}"
  icon="pi pi-exclamation-triangle">
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>

<wl-reports-query-tool-date-param-dialog
  (onDateChanged)="acceptDateParams($event)"></wl-reports-query-tool-date-param-dialog>
